<template>
  <BreadCrumb PageTitle="Vertical Rule" />
  <VerticalRule />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import VerticalRule from "../../template-components/Utilities/VerticalRule/VerticalRule.vue";

export default defineComponent({
  name: "VerticalRulePage",
  components: {
    BreadCrumb,
    VerticalRule,
  },
});
</script>